<sh-text size="super-header" class="section-title"> Getting Started with ExpertGuidance </sh-text>

<div class="card-container">
  <sh-card
    class="custom-card"
    label="Login: Your Personalized Training, One Tap Away" 
    image="assets/images/Login-image.png" 
  >
    <div size="title-1" class="card-content">
      Log in securely using your facility credentials to explore a personalized
      VR experience of your Siemens Healthineers equipment, it's look, feel, and
      functionality in real time. Whether you're onboarding or refreshing your
      skills, your custom dashboard is ready when you are.
    </div>
    <div class="card-footer">
      <sh-button
        color="secondary"
        size="m"
        label="Learn More"
        (click)="onLoginModalClick()"
      ></sh-button>
    </div>
  </sh-card>

  <sh-card
    class="custom-card"
    label="License Activation: Unlock Full Access Instantly"
    image="assets/images/License-activation.png"
  >
    <div size="title-1" class="card-content">
      Already have the app? Let’s get you started. Activate your license with
      the key from your administrator to unlock full access to immersive
      training modules. This one-time setup ensures your experience matches your
      facility’s equipment and protocols. Need help? Our support team is just a
      click away.
    </div>
    <div class="card-footer">
      <sh-button
        color="secondary"
        size="m"
        label="Learn More"
        (click)="onLicenseModalClick()"
      ></sh-button>
    </div>
  </sh-card>
</div>

<backend-login-modal #loginModal></backend-login-modal>
<backend-license-modal #licenseModal></backend-license-modal>
